export const SET_CATEGORY_SALES_LOADING = 'SET_CATEGORY_SALES_LOADING';
export const GET_CATEGORY_SALES_SUCCESS = 'GET_CATEGORY_SALES_SUCCESS';
export const GET_CATEGORY_SALES_ERROR = 'GET_CATEGORY_SALES_ERROR';
export const CLEAR_CATEGORY_SALES_ERROR = 'CLEAR_CATEGORY_SALES_ERROR';


